import { Card } from '../ui/card';
import { Checkbox } from '../ui/checkbox';
import { Label } from '../ui/label';
import { useLicense } from '../../lib/license';
import { ACTION_LABELS, PERMISSION_GROUPS } from '../../lib/permissions';

const Box = ({ id, label, checked, disabled, onChange }) => (
  <div className="flex items-center gap-2">
    <Checkbox id={id} checked={checked} disabled={disabled} onCheckedChange={onChange} data-testid={`perm-${id}`} />
    <Label htmlFor={id} className="text-sm font-normal">{label}</Label>
  </div>
);

const ModuleCard = ({ m, perms, disabled, onChange }) => {
  const p = perms?.[m.key] || {};
  return (
    <Card className="p-4" data-testid={`perm-module-${m.key}`}>
      <h4 className="mb-3 font-medium">{m.label}</h4>
      <div className="flex flex-wrap gap-4">
        {m.actions.map(a => <Box key={a} id={`${m.key}-${a}`} label={ACTION_LABELS[a]} checked={p[a] === true} disabled={disabled} onChange={v => {
          onChange(m.key, a, v === true);
          if (a === 'view' && v === true && !p.view) (m.tabs || []).forEach(([t]) => onChange(m.key, `tab_${t}`, true));
        }} />)}
      </div>
      {m.tabs && (
        <div className="mt-3 border-t border-slate-100 pt-3">
          <p className="mb-2 text-xs font-medium uppercase tracking-wide text-slate-400">Sekmeler</p>
          <div className="flex flex-wrap gap-4">
            {m.tabs.map(([t, l]) => <Box key={t} id={`${m.key}-tab-${t}`} label={l} checked={p[`tab_${t}`] === true} disabled={disabled || p.view !== true} onChange={v => onChange(m.key, `tab_${t}`, v === true)} />)}
          </div>
        </div>
      )}
    </Card>
  );
};

// Platform Owner'da kapalı eklentilerin yetkileri gizlenir (kayıtlı kalır, eklenti açılınca geri gelir)
export const PermissionsEditor = ({ permissions, disabled, onChange }) => {
  const { hasAddon } = useLicense();
  return (
    <div className="space-y-6">
      <p className="text-sm text-slate-500">Her menü için yetkileri, sekmeli sayfalarda görülebilecek sekmeleri seçin. Sekmeler için önce Görüntüleme yetkisi gerekir.</p>
      {PERMISSION_GROUPS.map(g => {
        const mods = g.modules.filter(m => !m.addon || hasAddon(m.addon));
        if (!mods.length) return null;
        return (
          <div key={g.title} className="space-y-3" data-testid={`perm-group-${g.title}`}>
            <h3 className="text-sm font-semibold text-slate-700">{g.title}</h3>
            {mods.map(m => <ModuleCard key={m.key} m={m} perms={permissions} disabled={disabled} onChange={onChange} />)}
          </div>
        );
      })}
    </div>
  );
};
